// here you put all the js you want.
import KitMedia from "./js/kitMedia.js";
import FichesTechniques from "./js/fichesTechniques";
import Process from "./js/process.js";
import Exemples from "./js/exemples.js";

const kitMedia = new KitMedia();
const fichesTechniques = new FichesTechniques();
const process = new Process();
const exemples = new Exemples();

let slider = tns({
  container: ".my-slider",
  items: 3,
  controlsContainer: "#controls",
  prevButton: ".previous",
  nextButton: ".next",
  speed: 1800,
  // loop:false,
  center: true,
  edgePadding: -500,
  navAsThumbnails: true,
  autowidth: true,
  gutter: 10,
  // fixedWidth:600,
  // mouseDrag: true,
});

function fenetre() {
  const sections = document.querySelectorAll("section");
  const text = document.querySelectorAll(".feat-text").forEach((a) => {
    a.addEventListener("click", (e) => {
      const sections = document.querySelectorAll("section");
      sections.forEach((section) => {
        if (section.id === e.target.id) {
          section.style.display = "block";
          // process();
        } else {
          section.style.display = "none";
        }
      });
    });
  });
}
fenetre();

function B2T() {
  const back2top = document.querySelector(".back2top");
  window.addEventListener("scroll", function () {
    back2top.classList.toggle("active", window.scrollY > 200);
  });
  back2top.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}
B2T();

const loader = document.querySelector(".loader");
const page = document.querySelector(".page");
window.addEventListener("load", () => {
  setTimeout(() => {
    loader.classList.add("fondu-out");
    page.style.display = "block";
  }, 300);
});
